const _ = importLib('lodash');
const M = importLib('moment');
const Vuex = importLib('Vuex');
const getHelpers = importLib('getHelpers');
const api = importLib('api');

const getImagePath = getHelpers('getImagePath');
const getAssetPath = getHelpers('getAssetPath');
const formatString = getHelpers('formatString');

_.mixin({
    imgPath: getImagePath,
    assetPath: getAssetPath,
    str: formatString,
    moment: M,
});

const priceCache = {

};

export default {
    computed: {
        ...Vuex.mapGetters({
            customer: 'customer',
            favorite_product_entries: 'favorite_product_entries',
            // timestamp: 'timestamp',
            route: 'route',
        }),

        _() {
            return _;
        },

        api() {
            return api;
        },

        contactLink() {
            return '/contact-us';
        },

        shopLink() {
            return '/shop';
            // return _.get(this.config, 'linkPrefix', '');
        },

        loggedIn() {
            return _.get(this.customer, 'attributes.registered');
        },

        favoriteProduct() {
            return _.chain(this.favorite_product_entries)
                .get('data')
                .find(fp => _.get(fp, 'attributes.product_id') == _.get(this.product, 'id') ||
                    _.get(fp, 'attributes.product_id') == _.get(this.product, 'attributes.product_id'))
                .value();
        },

        isFavorite() {
            return Boolean(this.favoriteProduct);
        },

        spinnerColor(){
            return '#23CCBE';
        }
    },

    methods: {
        __(value, format = null) {
            return formatString(value, format);
        },

        env(key = null) {
            return _.get(window, _.filter(['env', key]));
        },

        randomKey() {
            return Math.floor(Math.random() * 1000000);
        },

        serialize(value) {
            return JSON.stringify(value);
        },

        isApproved(product) {
            const approvedProductIds = _.get(this.customer, 'attributes.approved_product_ids');

            if (approvedProductIds == '*') {
                return true;
            }

            if (_.includes(approvedProductIds, product.id)) {
                return true;
            }

            return false;
        },

        getProductEnquiry(product) {
            return _.get(product, 'attributes.name') + '('+ _.get(product, 'attributes.base_code') +')';
        },

        getProductLink(product) {
            const attributes = _.get(product, 'attributes', product);
            let path = _.get(attributes, 'full_path') || _.get(attributes, 'path');

            return '/' + path;
            // const categoryLink = _.get(attributes, ['categories', '0', 'path']);
            // const productLink = _.get(attributes, ['name_id']);
            // return _.chain([
            //     this.shopLink, categoryLink, productLink
            // ]).filter().join('/').value();
        },

        getSwatch(swatches) {
            if(swatches){
                let colors = _.split(swatches, ',');
                if(colors.length > 1){
                    let stops = 100 / colors.length;
                    let i = 0;
                    let gradients = [];
                    _.forEach(colors, (color) => {
                        gradients.push(`${color} ${i}%`);
                        if(i<=100){
                            i+=stops;
                        }
                        gradients.push(`${color} ${i}%`);
                    });
                    let bgImg = `background-image:linear-gradient(90deg, ${_.join(gradients, ', ')})`;
                    return bgImg;
                }
                return `background-color:${swatches};`;
            }
        },

        getPriceAmount(price) {
            if (!price) return 0;

            if (!priceCache[price.id]) {
                const priceField = _.get(this.customer, 'attributes.price_field') || 'price';
                const attributes = _.get(price, 'attributes', price);
                const sale_price = _.get(attributes, 'sale_price', 0)

                priceCache[price.id] = sale_price > 0 ? sale_price : _.get(attributes, 'price', 0)
            }

            return priceCache[price.id];
        },

        getRRPAmount(price) {
            const attributes = _.get(price, 'attributes', price);
            return _.get(attributes, 'rrp', 0);
        },

        getWasPriceAmount(price) {

            const attributes = _.get(price, 'attributes', price);
            let rrp = _.get(attributes, 'rrp', 0);
            let our_price = _.get(attributes, 'price', 0);
            let sale_price = _.get(attributes, 'sale_price', 0);

            return sale_price > 0 ? our_price : rrp;
        },

        getSalePriceAmount(price) {
            const attributes = _.get(price, 'attributes', price);
            return _.get(attributes, 'sale_price', 0);
        },

        getDiscountAmount(price) {
            if (!price) return 0;

            const attributes = _.get(price, 'attributes', price);

            let sale_price = _.get(attributes, 'sale_price', 0);
            let our_price = _.get(attributes, 'price', 0);
            let rrp = _.get(attributes, 'rrp', 0);

            let discount = (sale_price > 0 ? (our_price - sale_price) : false);

            return discount;
        },

        isDiscounted(price){
            let discount = this.getDiscountAmount(price);
            return discount > 0 ? true : false;
        },

        updateComparedMenu() {
            let count = _.get(this.compared_product_entries, 'data').length;
            $('#compared-menu-count').html(`${count > 0 ? count : ''}`);
        },

        updateWishlistMenu() {
            let count = _.get(this.favorite_product_entries, 'data').length;
            $('#wishlist-menu-count').html(`${count > 0 ? count : ''}`);
        },

        isElementInViewport(el) {
            var rect = document.querySelector(el).getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
            );
        },

        scrollToElement(element){
            document.querySelector(element).scrollIntoView({
                behavior: 'smooth'
            });
        },
    }
}
